import './utils/safePointerCapture';
import './utils/dprClass';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';
import reportWebVitals from './reportWebVitals';
import { checkSessionOnly } from './utils/sessionOnly';

const root = ReactDOM.createRoot(document.getElementById('root'));
// Eerst kijken of een login zonder "Remember me" de browser niet overleeft
// (zie utils/sessionOnly.js); daarna pas renderen.
checkSessionOnly().then(() => {
  root.render(
    <React.StrictMode>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </React.StrictMode>
  );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
